import React from "react";

export default function RatingIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.43 7.64059C17.6944 7.68218 17.914 7.86707 18 8.12059C18.0867 8.38702 18.0037 8.67944 17.79 8.86059L14.4 12.1606L15.2 16.8306C15.2478 17.0925 15.1384 17.3583 14.92 17.5106C14.8013 17.5978 14.6572 17.6435 14.51 17.6406C14.398 17.6438 14.2873 17.6161 14.19 17.5606L9.99996 15.3606L5.80996 17.5306C5.57821 17.66 5.29191 17.6404 5.07996 17.4806C4.86155 17.3283 4.75211 17.0625 4.79996 16.8006L5.59996 12.1306L2.17996 8.83059C1.98893 8.64793 1.91903 8.3722 1.99996 8.12059C2.09074 7.85833 2.32417 7.67158 2.59996 7.64059L7.27996 6.96059L9.36996 2.72059C9.50093 2.49686 9.74072 2.35938 9.99996 2.35938C10.2592 2.35938 10.499 2.49686 10.63 2.72059L12.72 6.96059L17.43 7.64059ZM12.96 11.9806C12.9223 11.7537 12.9968 11.5227 13.16 11.3606L15.8 8.82059L12.16 8.29059C11.9301 8.26243 11.7304 8.11924 11.63 7.91059L9.99996 4.61059L8.36996 7.91059C8.26952 8.11924 8.06981 8.26243 7.83996 8.29059L4.19996 8.82059L6.83996 11.3606C6.9985 11.5369 7.05853 11.7808 6.99996 12.0106L6.41996 15.6306L9.66996 13.9206C9.87701 13.8138 10.1229 13.8138 10.33 13.9206L13.58 15.6006L12.96 11.9806Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
